import React, { useState, useRef, useEffect } from 'react'
import select from 'react-select'
import { Button, FloatingLabel, Form, Row, Col } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import PasswordInput from './PasswordInput';

import Carrera from './Carrera';
import Servicios from './Servicios';
import Especialidades from './Especialidades';
import Estados from './Estados';

//import { useForm } from "../../../node_modules-back/react-hook-form/dist";
import Footer from '../Footer/Footer';

import { useForm } from "react-hook-form";
// import './styles.css'
import "../../styles/AddLawer2Styles.css"
import FadeIn from './FadeInLawyer.js';
import axios from "axios";
import { getUrl } from "../../ApiCall/GetUrl";



import LoadPhoto from './LoadPhoto.js';
import Fechas from './Fechas.js';
import Languages from './Languages.js';
import PhoneInternational from './PhoneInternational/PhoneInternational.js';
import EstadosGlobal from './EstadosGlobal.js';
import RfcGlobal from './RfcGlobal.js';

import AddClientPhone from '../Client/AddClientPhone.js';


export default function AddLawer2() {


  const data = [

    {
      name : "licenciatura" ,
      univ : "" ,
      educacion : ""

   } ,
    {
      name : "maestria" ,
      univ : "" ,
      educacion : ""

    } ,
    {
      name : "doctorado" ,
      univ : "" ,
      educacion : ""

    } ,
    {
      name : "diplomado" ,
      univ : "" ,
      educacion : ""

    } ,


  ]

  

  const [showPassword, setShowPassword] = useState(false);
  //const [nombre,setNombre] = useState("")
  //const [correo,setCorreo] = useState("")
  const [telefono,setTelefono] = useState("55")
  //const [password,setPassword] = useState("") // Esta pendiente password
  const [descripcion, setDescripcion] = useState("")
  const [despacho, setDespacho] = useState("")
  const [posicion, setPosicion] = useState("")
  const [ubicacion, setUbicacion] = useState("")
  const [matricula, setMatricula] = useState("")

  const [theLoadPhoto,setTheLoadPhoto] = useState( false ) // Por default no se pone la carga de la photo
  const [image,setImage] = useState( null ) ;
  const [image64,setImage64] = useState( null )
  const [languages,setLanguages] = useState([])

  const [licenciatura,setLicenciatura] = useState( null)
  const [maestria,setMaestria] = useState( null)
  const [doctorado,setDoctorado] = useState( null)
  const [diplomado,setDiplomado] = useState( null)
  const [espPrecio,setEspPrecio] = useState( null )
  const [servicio,setServicio] = useState( false )
  const [rfc,setRfc] = useState( null )
  const [estado,setEstado] = useState( null )

  const [thePhone,setThePhone] = useState("")
  const [myInput,setMyInput] = useState(null)

  const [mailValue,setMailValue] = useState("")



  function onMailChance( e )
  {
    console.log( "Mail = " , e.target.value.toLowerCase() )

    setMailValue( e.target.value.toLowerCase() )
  }


  function setMatricula2( val )
  {

    var value = document.getElementById( 'matricula').value 

    //console.log( "Matricula = " , value )

    if ( value !== "")
    {
      if ( isNaN( value[value.length-1] ) === true )
      {
        return ;
      }
    }
    setMatricula( value)
  }


  function setTheTelefono( val )
  {

    var tel = document.getElementById( "telefono").value ;

    //console.log( "Telefono = " , tel )

    if ( isNaN( tel[tel.length -1] ) )
    {
      return ;
    }

    setTelefono( tel )
  }


  function setServicioPrev( val )
  {
    console.log("setServicioPrev = " , val )
    //setServicio( val )
  }


  function postData( data )
  {

    console.log( "Data en lawyer = " , data )
    //return ;

    axios.post(getUrl() +"lawyres" ,data )
    .then((result) =>{

    })
    .catch((err) =>{
      console.log( "error = " + err )
    })

  }


  useEffect(() =>{


    //console.log( "image64 = " + image64 )

  },[image64])

  function setImagePrev( e )
  {
    setImage( e ) ;

    convertToBase64( e ) ;

    //console.log( "base54 = " , b64 )
  }

  function convertToBase64( e )
  {
    const file = e

    const reader = new FileReader()


    reader.onloadend = () => {
      setImage64( reader.result.toString())
    }

    reader.readAsDataURL(file)
  }


  function onEspPrecio( val )
  {

    console.log( "onEspprecio = " , val ) ;

    var retVal = especValues( val.especialidad )

    console.log( "retVal = " , retVal)

    console.log( "precio = " + val.precio )

    setEspPrecio( val )
  }


  function onInputChange( val )
  {
    console.log( "onInputChange ** " , val )

    if ( val.id_academic_degree === 1) // "licenciatura"
    {



      if ( val.institution_degree.trim() === "" /* || val.name_degree.trim() === ""*/ )
      {
        console.log( "No hay nada en licenciatura")
        setLicenciatura( null )
        return ;
      }

      console.log( "Si hay algo en licenciatura")
      setLicenciatura( val )
      return ;
    }


    if ( val.id_academic_degree === 2 ) // "maestria"
    {

      if ( val.institution_degree.trim() === "" /* || val.name_degree.trim() === ""*/ )
        {
          setMaestria( null )
          return ;
        }

        setMaestria( val )
        return ;
    }

    if ( val.id_academic_degree === 3 )//"doctorado"
      {

        if ( val.institution_degree.trim() === "" /* || val.name_degree.trim() === ""*/ )
          {
            setDoctorado( null )
            return ;
          }

          setDoctorado( val )
          return ;
      }

      if ( val.id_academic_degree === 4 ) // "diplomado"
        {
          if ( val.institution_degree.trim() === "" /* || val.name_degree.trim() === "" */ )
            {
              setDiplomado( null )
              return ;
            }

            setDiplomado( val )
            return ;
        }
    

        console.log( "No lo encuento ************")
    
  }

  function setTheLoadPhotoPrev( val )
  {
    setTheLoadPhoto( val )

    console.log( "Se programa timer")

    setTimeout( () =>{

      setTheLoadPhoto( false ) ;

    } , 10000 )

  }

  



function verifyData( from )
{


  console.log( "from = " + from )

  var eMail = getValues( "correo")


  if ( eMail === null || eMail === "" )
  {
    console.log( "No se capturo correo")
    return ;
  }


  var password = getValues( "password")


  if ( password === null || password === "" )
  {
    console.log( "No se capturo password")
    return ;
  }


  var nombre = getValues( "nombre")

  console.log( "nombre == " + nombre )


  if ( nombre === null || nombre === "" )
  {
    console.log( "No se capturo nombre")
    return ;
  }

  var appaterno = getValues( "appaterno")

  console.log( "appaterno == " + appaterno )


  if ( appaterno === null || appaterno === "" )
  {
    console.log( "No se capturo apellido paterno")
    return ;
  }

  // fInicio , birthday


  var fInicio = getValues( "fInicio")

  console.log( "fInicio == " + fInicio )


  if ( fInicio === null || fInicio === "" )
  {
    console.log( "No se capturo fInicio")
    return ;
  }

  var birthday = getValues( "birthday")

  console.log( "birthday == " + birthday )


  if ( birthday === null || birthday === "" )
  {
    console.log( "No se capturo birthday")
    return ;
  }


  // lawyer_photograph


  if ( image64 === null )
  {
    console.log( "No se ha capturado la imagen")
    //return ; // LO dejamos sin verificar
  }


  var matricula = getValues( "matricula")

  console.log( "matricula == " + matricula )


  if ( matricula === null || matricula === "" )
  {
    console.log( "No se capturo matricula")
    return ;
  }


  var descripcion = getValues( "descripcion")

  console.log( "descripcion == " + descripcion )


  if ( descripcion === null || descripcion === "" )
  {
    console.log( "No se capturo descripcion")
    alert( "No se capturo descripcion")
    return ;
  }
  if ( estado.country === null )
  {
    console.log( "No se ha seleccionado pais")

    alert( "No se ha seleccionado pais")

    return ;
  }

  if ( estado === null )
  {
    console.log( "No se ha seleccionado estado")

    alert( "No se ha seleccionado estado")

    return ;
  }


  var states = [] ; states.push( estado ) // Aqui ponemos el arreglo de estados

  if ( estado.estate === null )
  {
    alert( "No se capturo el estado")
  }

  console.log( "esPrecio = " , espPrecio)

  //return ;


  if ( espPrecio === null || espPrecio.especialidad === null || espPrecio.precio === null  )
  {
    console.log( "No se capturo especialidad precio ")

    alert( "No se capturo especialidad precio ")

    if ( espPrecio.checkPrimer && espPrecio.checkValue === null )
    {
      alert( "No se capturo monto precio primer caso")
    }

    return ;
  }

  if ( licenciatura === null )
  {
    console.log( "Al menos se debe capturar la licenciatura")

    alert( "Al menos se debe capturar la licenciatura")

    return ;
  }

  

  var gradoAcademico = []

  gradoAcademico.push( licenciatura ) ;


  if ( maestria === null )
  {
    //console.log( "Al menos se debe capturar la maestria")

    //return ;
  }
  else{
    gradoAcademico.push( maestria ) ;
  }


  
  
  if ( doctorado === null )
  {
    //console.log( "Al menos se debe capturar la doctorado")

    //return ;
  }
  else{
    gradoAcademico.push( doctorado ) ;
  }


  if ( diplomado === null )
    {
      //console.log( "Al menos se debe capturar la diplomado")
  
      //return ;
    }
    else{
      gradoAcademico.push( diplomado ) ;
    }
    
  if( rfc === "")
  {
    alert( "No se capturo RFC")

    return ;
  }



  var data = {
    lawyer_email : eMail , // ok
    lawyer_password : password , // ok
    lawyer_name : nombre , // ok 
    lawyer_appaterno : appaterno , // ok
    lawyer_apmaterno : getValues( "apmaterno") , // ok este es opcional
    lawyer_working_begin_date : fInicio , // ok 
    lawyer_birthday : birthday , // ik
    lawyer_photograph : image64 , // Aqui la imagen en base 64 // ok
    lawyer_status : 1 , // Checar que es 1 // ok 
    lawyer_matricula : matricula , // ok
    lawyer_begin : new Date() , // ok 
    lawyer_services : (servicio === true  ? 2 : 1 ),  // ok 
    lawyer_description : descripcion , // ok 
    lawyer_rfc : rfc , // ok 
    //lawyer_state : estado , // ok
    lawyer_state : null ,


    lawyer_country : estado.country ,
    lawyer_estado : estado.state ,
    lawyer_city : estado.city ,

    lawyer_status_legaltek : 1 , // ok 
    id_lawyer_costo : espPrecio.precio ,

    lawyer_first_charge : (  espPrecio.checkPrimer === undefined || espPrecio.checkPrimer === false ?  null  : espPrecio.valuePrimer  ) ,
    dTimeStamp : new Date() ,
    //especialidades : espPrecio.especialidad ,
    //grado_academico : gradoAcademico ,

  }

  //console.log( "checkPrimer = " + espPrecio.checkPrimer , "  checkValue = " + espPrecio.valuePrimer )

  data = AddClientPhone( data , thePhone , myInput , "lawyer_phone")

  //console.log( "Date = " , data )

  //return ;

  var fullData = {
    main : data ,
    //espec : [2,3] , // especValues( espPrecio.especialidad ), // Especialidades del abogado
    espec:  especValues( espPrecio.especialidad ) ,
    languages :especValues( languages ) , //
    state : estado , // Lo debemos de meter a un arreglo
    academic_degrees : especAcademic( gradoAcademico ) , //
    dTimeStamp : new Date()  
  }

// { '{"main":"Hola como estan ???"}': '' }

  console.log( "data = " ,  JSON.stringify( fullData ) )


  //return ;

  axios.post( getUrl() +  "/post_lawyer" , JSON.stringify( fullData ) ,  {
    headers: {
      // Overwrite Axios's automatically set Content-Type
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }} )
  .then((result) =>{

    console.log( "result = " , result )

    if ( result.data.status === 0 )
    {
      //console.log( "Se guardo correctamente***")
      alert( "Se guardo correctamente")
      return ;
    }
    else{

      if ( result.data.status === -2 )
      {
        alert( "El eMail ya esta dado de alta")
        return ;
      }


      console.log( "No se guardo correctamente")
    }

  })
  .catch((err) =>{
    console.log( "error = " + err )
  })

  

}

function especValues( data ) // Sirve para cualquier tipo de arreglo
{
  var arr = []

  for ( var i = 0 ; i < data.length ; i++ )
  {
    arr.push( data[i].value )
  }

  console.log( "arr = " + arr)



  return arr ;
}

function especAcademic( data ) // Sirve para cualquier tipo de arreglo
{
  var arr = []

  for ( var i = 0 ; i < data.length ; i++ )
  {
    arr.push( data[i])
  }

  return arr ;
}

  function onError( errors )
  {
      console.log( "onError " , errors)


      console.log( "getValues birthday= " , getValues("birthday"))
      console.log( "getValues licenciatura = " , getValues("licenciatura"))


      if ( licenciatura === null ) // maestria , doctorado , diplomado
      {
        console.log( "No se capturo licenciatura")
      }
      else{
        console.log( "Si se capturo licenciatura")
      }


      if ( maestria === null )
      {
        console.log( "No se capturo maestria")
      }
      else{
        console.log( "Si se capturo maestria")
      }


      if ( doctorado === null )
      {
        console.log( "No se capturo doctorado")
      }
      else{
        console.log( "Si se capturo doctorado")
      }
  
      if ( diplomado === null )
      {
        console.log( "No se capturo diplomado")
      }
      else{
        console.log( "Si se capturo diplomado")
      }

      console.log( "languages.length = " + languages.length )
  
      if ( image === null )
      {
        console.log( "No se ha cargado la imagen")
      }

      //verifyData( "onError")
  }

  useEffect(() =>{

    console.log( "Cambio de imagen")

  } ,[image])

  // register, handleSubmit, clearErrors, control, formState: { errors }
  // Actualizador para mostrar errores
  useEffect(() => {
    console.log("Reinicio para errores")
    document.getElementById("finalizar")
    setTimeout(clearErrors, 10);
  }, [])

  const [posicionArr, setPosicionArr] = useState([]);
  useEffect(() => {
    axios.get(getUrl() + "/get_lawyer_position").then(response => {
      setPosicionArr(response.data);
      console.log("Este es el response.data: ", response.data)
    }).catch(error => {
      console.log("Error fetching data: ", error)
      setPosicionArr(["Hubo un error al obtener la información"])
    });
  }, [])



  const {
    register,
    formState: { errors },
    handleSubmit,
    //setError ,
    watch,
    clearErrors,
    getValues ,
    control
  } = useForm(/*{
        defaultValues: {
          legal: { 
            nombre : "" , 
            correo: "" ,
 
            
          } 
        }
      }*/);


  //console.log(watch('correo'));


  function handleSub(e) // Lo recortamos para evitar redundancia
  {

    //e.preventDefault() ;
    console.log("handleSub");

    if ( image === null )
    {
      console.log( "No se ha cargado la imagen") 
    }
    else{
      console.log( "Si tenemos la imagen cargada")
    }

    console.log( "Nos vamos a verifyData") ;

    verifyData( "handleSubmit")

  }



  // const togglePasswordVisibility = () => {
  //     setShowPassword(!showPassword);
  //   };
  // {...register('telefono', { required: false })}
  return (
    <>
      <div className='screen'>
        <div>
          <FadeIn></FadeIn>
        </div>
        <div className='box-login box-login-aux ' id="theDiv" >

          <div className='d-flex flex-column align-items-center espacio-box-login-form'>


            <div className='register-gray-box'> 

              <h2 className='mt-3 registrate-text'>
                <span>Regístrate</span> </h2>

              <div className='mt-4 text-center' >
                <p className="promocion-text">Y recibe tus primeros dos clientes de forma completamente gratuita.</p>
              </div>


            </div>

            <div className='display-label-none  mt-5 w-100 fondo-form' >

              <Form onSubmit={handleSubmit(handleSub,onError)} className="form-tag">

                {/* {
                        nombre !== "" && (
                            <p>Cambio nombre</p>
                        )
                    }
                     */}

                <div className='row g-0 mb-3 pt-3'>

                  <div className='col-sm-3'>
                    <div className="form-group">
                      <label className={"estilo_label"} htmlFor="nombre">Nombre </label>
                      <input type="text" className={"form-control border-0 border-bottom estilo_input"} id="nombre" title='Nombre de Abogado'

                        {...register('nombre', { required: "Nombre campo requerido" })}
                      />

                    </div>
                  </div>

                  <div className='col-sm-3'>
                    <div className="form-group">
                      <label className={"estilo_label "} htmlFor="nombre">Apellido Paterno </label>
                      <input type="text" className={"form-control border-0 border-bottom estilo_input derecha"} id="appaterno" title='Apellido Paterno'

                        {...register('appaterno', { required: "Apellido Paterno  requerido" })}
                      />

                    </div>
                  </div>

                  <div className='col-sm-3'>
                    <div className="form-group">
                      <label className={"estilo_label "} htmlFor="nombre">Apellido Materno </label>
                      <input type="text" className={"form-control border-0 border-bottom estilo_input derecha"} id="apmaterno" title='Apellido Materno'

                        {...register('apmaterno')}
                      />

                    </div>
                  </div>


                  <div className='col-sm-3'>
                    <div className="form-group"   >
                      <label className={"estilo_label derecha"} htmlFor="correo">Correo Electrónico</label>
                      <input type="email" value={mailValue}
                        className={"form-control  border-0 border-bottom border-start estilo_input derecha"} id="correo" title='Correo de Abogado'
                        {...register('correo', { required: "Correo , campo requerido" , onChange:(e) => onMailChance(e)})}
                      />

                    </div>
                  </div>

                </div>


                <EstadosGlobal setRfc={setRfc} setEstado={setEstado}></EstadosGlobal>


                <div className='row mb-3 pt-3'>
                  <div className='col-6 errtype'>
                    {errors.nombre && (<p >{errors.nombre.message}</p>)}
                  </div>
                  <div className='col-6 errtype'>
                    {errors.correo && (<p >{errors.correo.message}</p>)}
                  </div>

                </div>

 


                <div className='row g-0 mb-3 pt-3'> {/* Esta es la carga de la foto */}

                  <div className='col-3 text-center foto-div' >


                    <p className={"estilo_label"}>Fotografía</p>



                  </div>

                  <div className='col-3'>


                  {
                    ( theLoadPhoto || true ) && (
                      <div className="foto-conditional-div">
                          <LoadPhoto showNormal={(val)=>setTheLoadPhoto(val)} setSelectedImage={(val)=>setImagePrev(val)}></LoadPhoto>
                      </div>

                      
                    )
                  }

                  </div>

                  <div className='col-6 mt-2 d-flex flex-column align-items-center'>

                    <div className='load-photo' onClick={()=>setTheLoadPhotoPrev(true)}>

                      {
                        image !== null && (                      
                        <img
                        alt="not found"
                        
                        width={"100%"} height={"100%"} 

                        resizeMode='contain'
                        
                        src={URL.createObjectURL(image)}
                      />


                        )
                      }


                    </div>

                  </div>

                </div>

                

                




                <div className='row g-0 mb-3 pt-5'>

                  <div className='col-sm-6'>
                    <div className="form-group"   >
                      <label className={"estilo_label"} htmlFor="telefono">Teléfono Celular </label>
                      {/* <input type="text" className={"form-control  border-0 border-bottom estilo_input "} value={telefono}
                        id="telefono" title='Teléfono de Abogado' onChange={(val) => setTheTelefono(val)}
                        
                      /> */}
                      <PhoneInternational id='telefono' thePhone={(val) => setThePhone(val)}
                        theInput={(val)=>setMyInput(val)}></PhoneInternational>

                    </div>
                  </div>

                  <div className='col-sm-6 password-input'>
                    {/* <div className="form-group"   >
                                <label htmlFor="password">Contraseña</label>
                                <input type="password" className="form-control" id="correo"  title='Contraseñs'
                                placeholder="Contraseña" style={{padding:'5px'}}
                                onChange={(n) => setPassword(n)} />
                                
                            </div> */}
                    {/* <div className="form-group">
                                <label htmlFor="password">Contraseña </label>
                                <input className='w-75 form-control' id='password'
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Enter your password"
                                />
                                <button onClick={togglePasswordVisibility}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>                         */}

                    <div className='pt-0'>
                      <PasswordInput register={register} />
                    </div>


                  </div>

                </div>

                <div className='row mb-3 pt-3'>
                  <div className='col-6 errtype'>
                    {errors.telefono && (<p >{errors.telefono.message}</p>)}
                  </div>
                  <div className='col-6 errtype'>
                    {errors.password && (<p >{errors.password.message}</p>)}
                  </div>

                </div>

                <div className='row g-0 mt-4 mb-3'>

                  <div className='col-12'>


                    <div className="form-group"   >
                      <label className={"estilo_label mb-3"} hhtmlFor="descripcion">Descripción Profesional </label>
                      <textarea className="form-control description-input" id="descripcion" title='Descripción Profesional'
                          maxLength={200}
                        // Cómo centrar este textarea
                        

                        {...register('descripcion', { required: "Descripción profesional , campo requerido" })}


                      />
                    </div>

                  </div>

                </div>

                <div className='row g-0 mb-3 pt-5'>

                  <div className='col-6'>
                    <div className="form-group"   >
                      <label className={"estilo_label"} htmlFor="despacho">Despacho</label>

                      <input type="text" className={"form-control  border-0 border-bottom estilo_input"} id="despacho" title='Despacho'
                      {...register('despacho', { required: false })}
                        onChange={(n) => setDespacho(n)} />

                    </div>

                  </div>

                  <div className='col-6'>

                    <div className="form-group"   >
                      <label className={"estilo_label derecha"} htmlFor="posicion">Posición</label>
                      <select type="text" placeholder='' className={"form-control  border-0 border-bottom border-start estilo_input derecha"}
                      {...register('posicion', { required: true })}
                      id="posicion" title='Posicion'>
                      
                        <option></option>
                        {posicionArr.map(v => <option key={
                          v.id_position
                        } value={
                          v.id_position
                        }>

                          {v.position}
                        </option>
                        )}
                      </select>

                    </div>


                  </div>


                </div>


                <div className='row g-0 mb-3 pt-5'>

                  <div className='col-6'>
                    <div className="form-group"   >
                      <label className={"estilo_label"} htmlFor="ubicacion">Ubicación Despacho</label>
                      <input type="text" className={"form-control  border-0 border-bottom estilo_input "} 
                      {...register('ubicacion', { required: true })}
                      id="ubicacion" title='Ubicacion'
                        onChange={(n) => setUbicacion(n)} />

                    </div>

                  </div>

                  
                  <div className='col-6'>

                    <div className="form-group"   >
                      <label className={"estilo_label derecha"} htmlFor="matricula">Cédula</label>
                      <input type="text" 
                        {...register('matricula', { required: true })}
                        className={"form-control  border-0 border-bottom border-start estilo_input derecha"} id="matricula" title='matricula'
                        onChange={(n) => setMatricula2(n)} value={matricula} />

                    </div>


                  </div>


                </div>

              

                <div className="fechas-input">
                  <Fechas control={control} errors={errors} name2={"fInicio"} name3={"birthday"}></Fechas>
                </div>
                

                <div className='mt-4'>

                  <p className={"subtitulos"}>Educación</p>

                </div>

                <Carrera title={'Licenciatura'} prefix={'lic'} inputChange={onInputChange}
                  control={control} name2={'licenciatura'} errors={errors} isRequired={true} />
                <Carrera title={'Maestria'} prefix={'mae'} inputChange={onInputChange}
                  control={control} name2={'maestria'} errors={errors} isRequired={true} />

                <Carrera title={'Doctorado'} prefix={'doc'} inputChange={onInputChange}
                  control={control} name2={'doctorado'} errors={errors} isRequired={true} />

                <Carrera title={'Diplomado'} prefix={'dip'} inputChange={onInputChange}
                  control={control} name2={'diplomado'} errors={errors} isRequired={true} />


                <Languages setLanguages={(val)=>setLanguages(val)}></Languages>


                <Servicios setServicio={ (val) => setServicioPrev(val)}  />
                {/*setServicio={ (val) => setServicioPrev(val)} */}
                <Especialidades setEpecialPrecio={onEspPrecio} />
                {/*<Estados setRfc={setRfc} setEstado={setEstado} onFinalizar={handleSubmit(handleSub) } />*/}

                
                

                <RfcGlobal setRfc={setRfc}></RfcGlobal>


              </Form>

            </div>

          </div>



        </div>
        <Footer oscuro={true}></Footer>

      </div>
    </>
  )
}
